import type Peer from '../engine/Peer';

interface PeerLogResponse {
  id: Peer['id'];
  appId: Peer['appId'];
  role: Peer['role'];
  groups: Peer['groups'];
  producePermissions: Peer['producePermissions'];
}

export function logResponse(peer: Peer): PeerLogResponse {
  return {
    id: peer.id,
    appId: peer.appId,
    role: peer.role,
    groups: peer.groups,
    producePermissions: peer.producePermissions,
  };
}
